import { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Phone, Copy, Check } from 'lucide-react';

export default function Help() {
  const { t } = useLanguage();
  const [copiedIndex, setCopiedIndex] = useState<number | null>(null);

  const contactNumbers = [
    {
      number: '0751 532 3827',
      name: 'Safeen Azad'
    },
    {
      number: '0751 243 6696',
      name: 'Mateen Soran'
    },
    {
      number: '0750 870 1883',
      name: 'Hassan Sirwan'
    }
  ];

  const copyNumber = async (number: string, index: number) => {
    try {
      await navigator.clipboard.writeText(number);
      setCopiedIndex(index);
      setTimeout(() => setCopiedIndex(null), 2000);
    } catch {
      // fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = number;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopiedIndex(index);
      setTimeout(() => setCopiedIndex(null), 2000);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white border-b border-slate-200">
        <div className="w-full px-4 sm:px-6 lg:px-8 py-6">
          <h1 className="text-2xl font-semibold text-slate-900 tracking-tight">{t('help.title')}</h1>
          <p className="text-slate-500 text-sm mt-0.5">{t('help.subtitle')}</p>
        </div>
      </header>

      <main className="w-full px-4 sm:px-6 lg:px-8 py-8">
        <Card className="rounded-2xl border border-slate-200 shadow-sm w-full">
          <CardHeader className="text-center">
            <CardTitle className="text-lg font-semibold text-slate-900">{t('help.contact')}</CardTitle>
            <CardDescription className="text-sm text-slate-500">
              {t('help.contactDescription')}
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-6">
            {contactNumbers.map((contact, index) => (
              <div key={index} className="flex items-center justify-between gap-4 p-6 bg-slate-50 rounded-xl border border-slate-200">
                <div className="flex items-center gap-4">
                  <Phone className="h-6 w-6 text-slate-600 shrink-0" />
                  <div>
                    <p className="text-xl font-semibold text-slate-900 tabular-nums">{contact.number}</p>
                    <p className="text-sm text-slate-600">{contact.name}</p>
                  </div>
                </div>
                <Button
                  variant="outline"
                  size="sm"
                  className="shrink-0 border-slate-200"
                  onClick={() => copyNumber(contact.number, index)}
                >
                  {copiedIndex === index ? (
                    <>
                      <Check className="h-4 w-4 mr-2 text-emerald-600" />
                      {t('help.copied')}
                    </>
                  ) : (
                    <>
                      <Copy className="h-4 w-4 mr-2" />
                      {t('help.copy')}
                    </>
                  )}
                </Button>
              </div>
            ))}
          </CardContent>
        </Card>
      </main>
    </div>
  );
}
